export default "__VITE_ASSET__GRruhTTI__"